import AbstractMappingValidator from './abstract-mapping-validator';
export default class RuleValidator extends AbstractMappingValidator {
    validate(rule) {
        this.errors = {};
        if (!rule) {
            return this.errors;
        }
        this.validateTitle(rule, this.errors);
        this.validateConditions(rule, this.errors);
        return this.errors;
    }
    validateTitle(rule, validationErrors) {
        if (!rule) {
            return;
        }
        const errors = [];
        if (!this.isValidString(rule.title)) {
            errors.push(this.i18n.t('general.validation.please_enter_title').toString());
        }
        if (errors.length > 0) {
            validationErrors.title = errors;
        }
    }
    validateConditions(rule, validationErrors) {
        if (!rule) {
            return;
        }
        const errors = [];
        const conditionCount = rule.conditions.length;
        if (conditionCount) {
            for (const index in rule.conditions) {
                const condition = rule.conditions[index];
                const conditionValidator = condition.validator;
                conditionValidator.index = parseInt(index);
                conditionValidator.conditionCount = conditionCount;
                if (Object.keys(conditionValidator.validate(condition)).length) {
                    errors.push(this.i18n.t('mapping.validation.condition_invalid', { index }).toString());
                }
            }
        }
        else {
            errors.push(this.i18n.t('mapping.validation.condition_required').toString());
        }
        if (errors.length > 0) {
            validationErrors.conditions = errors;
        }
    }
}
//# sourceMappingURL=rule-validator.js.map